/**
 * Types connexions plateformes (S6 PR1) — alias FE typés sur le codegen
 * OpenAPI.
 *
 * Source de vérité : `backend/app/schemas/platform_connections.py`. Le
 * pattern est identique à `types/pod.ts` — pas de mapper BE↔FE, les rows
 * sont consommées telles quelles côté hooks/composants.
 */

import type { components } from './api-generated'

export type Platform = components['schemas']['Platform']

export type PlatformConnectionResponse = components['schemas']['PlatformConnectionResponse']

export type EtsyOAuthStartResponse = components['schemas']['EtsyOAuthStartResponse']

export type PinterestOAuthStartResponse = components['schemas']['PinterestOAuthStartResponse']

export type PinterestBoardResponse = components['schemas']['PinterestBoardResponse']

// S7-PR2 — Publish + admin
export type PinterestPublishRequest = components['schemas']['PinterestPublishRequest']
export type PinterestPublishResponse = components['schemas']['PinterestPublishResponse']
export type PinterestQuotaState = components['schemas']['PinterestQuotaState']
export type PinterestMarkStandardResponse = components['schemas']['PinterestMarkStandardResponse']
export type PinterestCancelBlockedResponse = components['schemas']['PinterestCancelBlockedResponse']

export type PinterestStrategy = PinterestPublishRequest['pinterest_strategy']

// Helpers d'affichage UI — labels FR pour <PlatformConnectionCard>.

export const PLATFORM_LABEL_FR: Record<Platform, string> = {
  etsy: 'Etsy',
  pinterest: 'Pinterest',
  instagram: 'Instagram',
  tiktok: 'TikTok',
  saatchi: 'Saatchi Art',
  artfinder: 'Artfinder',
}

// Plateformes effectivement câblées (adapter réel ≠ MockAdapter +
// is_implemented=True côté enum BE). Mis à jour à chaque sprint plateforme :
//   S6  → etsy
//   S7  → pinterest
//   S8  → instagram
//   S9  → tiktok
//
// L'UI grise les cartes des plateformes pas encore implémentées au lieu
// de proposer un Connect qui échouerait silencieusement.
export const PLATFORM_IS_IMPLEMENTED: Record<Platform, boolean> = {
  etsy: true,
  // S7-PR1 : Pinterest = OAuth + boards sync livrés. La carte propose
  // donc « Connecter » (≠ « Bientôt disponible » grisé). Côté BE
  // `Platform.PINTEREST.is_implemented` reste `False` tant que PR2 n'a
  // pas câblé `publish` (verrou adapter_complete). Sémantique distincte
  // FE↔BE : ce flag FE pilote l'UX OAuth, le flag BE pilote la
  // capability publish/metrics.
  pinterest: true,
  instagram: false,
  tiktok: false,
  saatchi: false,
  artfinder: false,
}

// Bandeau d'aide affiché par <PlatformConnectionCard> avant connexion.
export const PLATFORM_TAGLINE_FR: Record<Platform, string> = {
  etsy: 'Vente directe (prints + originaux + digital). Marketplace n°1 art.',
  pinterest: 'Distribution visuelle. Pins épinglés sur les boards des collectionneurs.',
  instagram: 'Réseau social — feed + reels + carousels.',
  tiktok: 'Vidéo verticale courte — time-lapse atelier.',
  saatchi: 'Galerie en ligne — originaux signés.',
  artfinder: 'Marketplace originaux fine art.',
}
